// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b7e00df","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/MarketplaceAccount/MercadoLivre/List.vue
// module id = 1504
// module chunks = 0